import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import Elevation from '@segment/matcha/components/Elevation'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import heroPng2x from './assets/HeroCCPA@2x.png'
import heroWebp from './assets/HeroCCPA.webp'
import heroWebp2x from './assets/HeroCCPA@2x.webp'
import heroWebp3x from './assets/HeroCCPA@3x.webp'

const copy = {
  heading: `Simplify CCPA compliance with Segment`,
  content: `Honor consumer rights under the California Consumer Privacy Act.`,
}

const Hero = () => {
  return (
    <Wrapper>
      <StyledSection variant="2Col">
        <Section.Copy>
          <CopyTextBase>
            <CopyText.Heading tag="h1" variant="h1">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description variant="pExtraLarge" tag="p">
              {copy.content}
            </CopyText.Description>
          </CopyTextBase>
        </Section.Copy>
        <Section.Contents>
          <Elevation elevation={1} type="dropShadow">
            <picture>
              <source type="image/webp" srcSet={`${heroWebp}, ${heroWebp2x} 2x, ${heroWebp3x} 3x`} />
              <Image width="614" height="450" src={heroPng2x} alt="Hero" />
            </picture>
          </Elevation>
        </Section.Contents>
      </StyledSection>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.green[10]};
`

const StyledSection = styled(SectionBase)`
  ${Section.Copy} {
    align-self: center;
  }
`

export default Hero
